import { render, staticRenderFns } from "./add_repair_modal.vue?vue&type=template&id=45ac47a5"
import script from "./add_repair_modal.vue?vue&type=script&lang=js"
export * from "./add_repair_modal.vue?vue&type=script&lang=js"
import style0 from "./add_repair_modal.vue?vue&type=style&index=0&id=45ac47a5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports